import { HTMLTemplateResult, html } from "lit";
import { StyleInfo } from "lit/directives/style-map.js";

export function constructGridTemplateRows(start: number, end: number): StyleInfo {
    const rows = getHours(start, end).map(hour => `0${hour}`.slice(-2))
        .map(el => [el + '00', el + '15', el + '30', el + '45'])
        .reduce((a, b) => a.concat(b))
        .map(el => `[g${el}] var(--timetable-row-height)`)
        .join(' ');
    return {gridTemplateRows: rows};
}

export function constructGridHourHtml(start: number, end: number, mini: boolean): HTMLTemplateResult {
    const hours = getHours(start, end)
        .map(hour => [hour + (mini ? '' : ':00'), '', '', ''])
        .reduce((a, b) => a.concat(b));
    return html`
        ${hours.map(el => html`
            <div>
                <div><span>${el}</span></div>
                <div></div>
            </div>
        `)}
    `;
}


function getHours(start: number, end: number): number[] {
    return [...Array(end - start + 1) as unknown[]]
        .map((_, idx) => start + idx);
}